import { useAuth } from '@nest/common-core-frontend-react';
import {} from '@nest/internal-frontend';
import { useValidationResultDialog } from '@nest/uikit-react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { useTerminalClient } from '../client-rpc-router';
import { TerminalScreen } from '../components/TerminalScreen';
import { useNumberParam } from '../helpers';
import { useCommandInboundDeliveryOrderOpenDocument } from './inbound/commands/inbound-delivery-order-open-document.command';
import { useCommandInboundDeliveryOrderStartProcess } from './inbound/commands/inbound-delivery-order-start-process.command';

export default function InboundDeliveryOrderDetailPage() {
	const client = useTerminalClient();
	const inboundDeliveryOrderId = useNumberParam('inboundDeliveryOrderId');
	const navigate = useNavigate();
	const auth = useAuth();
	const queryClient = useQueryClient();

	const query = useQuery({
		queryKey: ['inbound-delivery-order', inboundDeliveryOrderId],
		queryFn: () =>
			client.inboundDeliveryOrders.getInboundDeliveryOrderById.execute({
				id: inboundDeliveryOrderId!,
				populate: ['lines', 'lines.stockItem', 'lines.stockItem.item', 'assignedTo']
			}),
		enabled: !!inboundDeliveryOrderId
	});

	const inboundDeliveryOrder = query.data;

	const startProcessingMutation = useMutation({
		mutationFn: (id: number) => client.inboundDeliveryOrderProcess.startInboundDeliveryOrderProcessMutation.execute({ id }),
		onSuccess: (_, id) => {
			queryClient.invalidateQueries({ queryKey: ['inbound-delivery-order', id] });
			navigate(`/inbound/delivery/orders/${id}/process`);
		}
	});

	useValidationResultDialog([query.error, startProcessingMutation.error]);

	const handleOpenDocument = () => {
		if (!inboundDeliveryOrder) return;
		navigate(`/inbound/delivery/orders/${inboundDeliveryOrder.id}/process`);
	};

	const commands = [
		useCommandInboundDeliveryOrderStartProcess({ inboundDeliveryOrder, startProcessingMutation }),
		useCommandInboundDeliveryOrderOpenDocument({ inboundDeliveryOrder, auth, onOpenDocument: handleOpenDocument })
	];

	return (
		<TerminalScreen showBackButton topBar={<div>{inboundDeliveryOrder?.documentNumber}</div>} commands={commands}>
			<div className="flex flex-col gap-4 h-full">
				<div className="flex flex-col gap-4">
					<div>Číslo dokladu</div>
					<div>{inboundDeliveryOrder?.documentNumber}</div>
					<div>Stav</div>
					<div>{inboundDeliveryOrder?.state}</div>
					<div>Přiřazeno k</div>
					<div>{inboundDeliveryOrder?.assignedTo?.name}</div>
				</div>
				<div className="flex flex-col gap-4 overflow-auto">{inboundDeliveryOrder?.lines?.map(line => <div key={line.id}>{line.stockItem?.item?.name}</div>)}</div>
				{/* Commands are now available in the top-right menu */}
			</div>
		</TerminalScreen>
	);
}
